import type {
  PurchaseProductOption,
  RewardConfiguration,
  RewardType,
} from '../types/voucher-product-form.types';
import { VOUCHER_REWARD_TYPE_OPTIONS } from './form-defaults';

export const DEFAULT_REWARD_CONFIGURATION: RewardConfiguration = {
  reward_type: 'DISCOUNT_PERCENT',
  min_total_quantity_all_item: null,
  is_bundling: false,
  reward_rule_products: [],
  discount_products: [],
  free_goods: [],
  discount_amount_value: null,
  discount_percentage_value: null,
  free_goods_quantity_value: null,
};

export const EMPTY_PRODUCT_OPTION: PurchaseProductOption = {
  value: '',
  label: '',
  min_quantity: 1,
};

export const OPTION_VALUE_TO_REWARD_TYPE: Record<
  (typeof VOUCHER_REWARD_TYPE_OPTIONS)[number]['value'],
  RewardType
> = {
  amount: 'DISCOUNT_AMOUNT',
  percent: 'DISCOUNT_PERCENT',
  free_goods: 'FREE_GOODS',
};

export const REWARD_DESCRIPTIONS: Record<RewardType, string> = {
  DISCOUNT_AMOUNT: 'Potongan harga jika melakukan pembelian produk di atas',
  DISCOUNT_PERCENT:
    'Potongan harga berdasarkan persentase jika melakukan pembelian produk di atas',
  FREE_GOODS: 'Produk gratis pilihan jika melakukan pembelian produk di atas',
};
